import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector, shallowEqual } from 'dva'
import Form from 'rc-field-form'
import { FormItem } from 'components'
import { LoginButton } from 'app/mobile/components'
import { PhoneInput, CodeInput } from 'app/mobile/components'
import { phoneValidator, getApplication } from 'utils'
import { loginRedirectUrl } from 'utils'

const selector = ({ login, loading }) => ({
  limit: login.limit,
  loading: ['login/onGeetest', 'login/login'].some(
    item => loading.effects[item]
  ),
})
export default function Index() {
  const dispatch = useDispatch()
  const { limit, loading } = useSelector(selector, shallowEqual)
  const history = useHistory()

  const [loginBut, setLoginBut] = useState(false)
  const [mobile, setMobile] = useState({})
  const [form] = Form.useForm()

  const onValuesChange = () => {
    const values = form.getFieldsValue()
    setLoginBut(values?.mobile && values?.validCode)
    setMobile(values?.mobile)
  }

  const __dev__ = process.env.NODE_ENV === 'development'
  const initialValues = {
    mobile: __dev__
      ? {
          mobile: '18311092677',
          areaCode: '+86',
        }
      : '',
    validCode: __dev__ ? '123456' : '',
  }

  useEffect(() => {
    if (__dev__) {
      setMobile({
        mobile: '18311092677',
        areaCode: '+86',
      })
    }
  }, [__dev__])

  const onFinish = values => {
    dispatch({
      type: 'login/login',
      payload: {
        areaCode: values.mobile.areaCode,
        mobile: values.mobile.mobile,
        validCode: values.validCode,
        returnUrl: loginRedirectUrl(),
        applicationCode: getApplication(),
        limit,
        loginType: 'phone',
        history,
      },
    })
  }

  return (
    <div>
      <Form
        form={form}
        onValuesChange={onValuesChange}
        onFinish={onFinish}
        initialValues={initialValues}>
        <FormItem
          name="mobile"
          rules={[
            { required: true, message: '请输入手机号码' },
            { validator: phoneValidator },
          ]}>
          <PhoneInput />
        </FormItem>
        <FormItem
          name="validCode"
          rules={[
            { required: true, message: '请输入验证码' },
            { pattern: /^\d{6}$/, message: '请输入正确的验证码' },
          ]}>
          <CodeInput mobile={{ ...mobile, smsType: 'VALIDATION_CODE' }} />
        </FormItem>
        <FormItem>
          <LoginButton disabled={!loginBut} loading={loading} />
        </FormItem>
      </Form>
    </div>
  )
}
